import React from 'react'
import {connect} from 'react-redux'
import {Flex, Box} from 'reflexbox'

import Waterfall from '../common/Waterfall'

import {TankAnimated, TankAnimatedArt} from './TankAnimated'
import OperationMode from './OperationMode'
import Supply from './Supply'
import Cistern from './Cistern'
import Energy from './Energy'
import DryWell from './DryWell'

const styles = {
  card: {
    height: '100%'
  },
  cardContainer: {
    paddingBottom: '30px',
    paddingLeft: '30px',
    minHeight: '50%'
  }
}

const getBuildingTanks = ({tanks = []}, informations) => {
  return tanks.map((tank, i) => <TankAnimated key={i} {...tank} informations={informations} />)
}

const DashboardPage = (props) => {
  return (
    <div>
      <TankAnimatedArt />
      <Flex wrap={true} style={{marginTop: '30px'}}>
        <Box col={12} md={3}>
          <Waterfall style={{paddingRight: '30px'}} flexProps={{justify: 'space-between'}} boxProps={{style: styles.cardContainer, col: 4, md: 12}}>
            {getBuildingTanks((props.buildings.length > 0 ? props.buildings[0] : {}), props.informations)}
          </Waterfall>
        </Box>
        <Box col={12} md={3}>
          <Flex wrap={true} style={{height: '100%', paddingRight: '30px'}}>
            <Box style={styles.cardContainer} col={6} md={12}>
              <OperationMode
                style={styles.card}
                informations={props.informations}
              />
            </Box>
            <Box style={styles.cardContainer} col={6} md={12}>
              <Supply
                style={styles.card}
                informations={props.informations}
              />
            </Box>
          </Flex>
        </Box>
        <Box col={12} md={3}>
          <Flex wrap={true} style={{height: '100%', paddingRight: '30px'}}>
            <Box style={styles.cardContainer} col={6} md={12}>
              <Cistern
                {...(props.cisterns[0] || {})}
                style={styles.card}
                informations={props.informations} />
            </Box>
            <Box style={styles.cardContainer} col={6} md={12}>
              <Cistern
                {...(props.cisterns[1] || {})}
                style={styles.card}
                informations={props.informations} />
            </Box>
          </Flex>
        </Box>
        <Box col={12} md={3}>
          <Flex wrap={true} style={{height: '100%', paddingRight: '30px'}}>
            <Box style={styles.cardContainer} col={6} md={12}>
              <DryWell
                style={styles.card}
                informations={props.informations} />
            </Box>
            <Box style={styles.cardContainer} col={6} md={12}>
              <Energy
                style={styles.card}
                informations={props.informations} />
            </Box>
          </Flex>
        </Box>
      </Flex>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  buildings: state.buildings,
  cisterns: state.cisterns,
  hubs: state.hubs,
  modules: state.modules,
  informations: state.informations,
  commands: state.commands
})

export default connect(mapStateToProps, null)(DashboardPage)



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/DashboardPage.js
 **/